import { PdfButton } from "@/controls/buttons/PdfButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Autocomplete, Box, TextField } from "@mui/material";
import type { RollNameOption } from "../models/RollTurnHistoryDetail";

interface Props {
	rollName: string | null;
	options: RollNameOption[];
	loadingOptions: boolean;
	onRollNameChange: (rollName: string | null) => void;
	onReset: () => void;
	canReset: boolean;
	onExportPdf: () => void;
	canExportPdf: boolean;
	exportingPdf: boolean;
}

export const RollTurnHistoryToolbar = ({
	rollName,
	options,
	loadingOptions,
	onRollNameChange,
	onReset,
	canReset,
	onExportPdf,
	canExportPdf,
	exportingPdf,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			px: 1.5,
			py: 0.75,
			flexWrap: "wrap",
		}}
	>
		<Box sx={{ minWidth: 220, maxWidth: 260 }}>
			<Autocomplete
				options={options}
				getOptionLabel={(option) => option.Name}
				isOptionEqualToValue={(option, value) => option.Name === value.Name}
				value={options.find((o) => o.Name === rollName) ?? null}
				onChange={(_, option) => onRollNameChange(option?.Name ?? null)}
				loading={loadingOptions}
				size="small"
				fullWidth
				autoHighlight
				renderInput={(params) => (
					<TextField
						{...params}
						label="Roll"
						placeholder="Specify foundry number"
					/>
				)}
			/>
		</Box>
		<ResetFiltersButton onClick={onReset} disabled={!canReset} />

		<Box sx={{ flexGrow: 1, minWidth: 8 }} />

		<Box sx={{ width: 200 }}>
			<PdfButton
				handleExportToPdf={onExportPdf}
				disabled={!canExportPdf}
				loading={exportingPdf}
			/>
		</Box>
	</Box>
);
